import ApiService from './apiService';

class UsersService {
    /**
     * Récupérer la liste des utilisateurs avec filtres et pagination
     */
    getUsers(params = {}) {
        return ApiService.get('/users', params);
    }

    /**
     * Récupérer un utilisateur par son ID
     */
    getUser(id, params = {}) {
        return ApiService.get(`/users/${id}`, params);
    }

    /**
     * Créer un nouvel utilisateur
     */
    createUser(userData) {
        return ApiService.post('/users', userData);
    }

    /**
     * Mettre à jour un utilisateur existant
     */
    updateUser(id, userData) {
        return ApiService.put(`/users/${id}`, userData);
    }

    /**
     * Supprimer un utilisateur
     */
    deleteUser(id) {
        return ApiService.delete(`/users/${id}`);
    }

    /**
     * Rechercher des utilisateurs
     */
    searchUsers(query, options = {}) {
        return ApiService.get('/users', {
            search: query,
            ...options
        });
    }

    /**
     * Activer/désactiver un utilisateur
     */
    toggleUserStatus(id, active) {
        return ApiService.put(`/users/${id}`, { active });
    }

    /**
     * Changer le rôle d'un utilisateur
     */
    changeUserRole(id, role) {
        return ApiService.put(`/users/${id}`, { role });
    }

    /**
     * Formater un utilisateur pour l'affichage
     */
    formatUserForDisplay(user) {
        if (!user) return null;

        return {
            ...user,
            formattedDate: user.created_at ? new Date(user.created_at).toLocaleDateString() : '',
            roleName: user.role === 'admin' ? 'Administrateur' : 'Utilisateur standard',
            statusText: user.active ? 'Actif' : 'Inactif'
        };
    }
}

export default new UsersService();